import { createSlice } from "@reduxjs/toolkit";
import { INotificationType } from "../../@types/notification-type";
import { fetchNotificationType } from "../../api/notification-type";

const initialState: { list: INotificationType[], loading: boolean } = {
  list: [],
  loading: false
};

const notificationTypeSlice = createSlice({
  name: "notificationType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchNotificationType.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false
    });
    builder.addCase(fetchNotificationType.pending, (state, action) => {
      state.loading = true
    })
  },
});

export const { } = notificationTypeSlice.actions;

export default notificationTypeSlice.reducer;
